export default __webpack_public_path__ + "static/media/Income tax.bedeca72.png";